
export const initPrintMe = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false)
}

// ##########################
// ### Doc event handlers ###
// Doc click
const onDocClick = (e) => {
  if (e.target.classList.contains("print-me")) {
    e.preventDefault()
    window.print()
  }
}
